<template>
  <div class="sub_title_01">
    <div class="width_wrap">
      <h1>{{ title }}</h1>
      <div class="title">
        <p :class="{ animateP: animateP }">{{ subtitle }}</p>
        <h2 :class="{ animateH2: animateH2 }" v-html="description"></h2>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

interface Props {
  title: string;
  subtitle?: string;
  description?: string;
}

const props = withDefaults(defineProps<Props>(), {
  subtitle: "",
  description: "",
});

const animateP = ref(false);
const animateH2 = ref(false);

onMounted(() => {
  setTimeout(() => {
    animateP.value = true;
  }, 300);
  setTimeout(() => {
    animateH2.value = true;
  }, 700);
});
</script>

<style>
.sub_title_01 p,
.sub_title_01 h2 {
  margin-top: 30px;
  opacity: 0;
  transition: all 0.7s ease;
}

.animateP {
  margin-top: 0 !important;
  opacity: 1 !important;
}

.animateH2 {
  margin-top: 0 !important;
  opacity: 1 !important;
}

.sub_title_01 {
  background: url("@/assets/img_up/shop_pds/kp708b/design/img/sub/subtop.jpg")
    no-repeat center top;
  border: 0;
  height: 250px;
}

@media screen and (max-width: 1100px) {
  .sub_title_01 {
    border-top: 1px solid #ccc;
    height: 0px;
  }
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}
</style>
